export const UPDATE_FOCUSED_PRODUCT_TILE = 'UPDATE_FOCUSED_PRODUCT_TILE'
export const RESET_FOCUSED_PRODUCT_TILE = 'RESET_FOCUSED_PRODUCT_TILE'
export const UPDATE_PRODUCTS = 'UPDATE_PRODUCTS'
export const UPDATE_SEO_CONF = 'UPDATE_SEO_CONF'
export const mutations = {
  [RESET_FOCUSED_PRODUCT_TILE]: function (state) {
    state.wcag.focusedTileId = null
  },
  [UPDATE_FOCUSED_PRODUCT_TILE]: function (state, payload) {
    state.wcag.focusedTileId = payload
  },
  [UPDATE_PRODUCTS]: function (state, payload) {
    state.products = payload
  },
  [UPDATE_SEO_CONF]: (state, payload) => {
    state.seo = Object.assign({}, state.seo, payload)
  },
}
